function timeStrToNumber(time) {
  if (time) {
    if (time.includes('ms')) {
      return parseInt(time) / 1000;
    }
    if (time.includes('min')) {
      return parseFloat(time) * 60;
    }
    if (time.includes('h')) {
      return parseFloat(time) * 3600;
    }
    if (time.includes(':')) {
      /*
       In a SMIL clock value the part after the seconds is a decimal FRACTION, not a count of
       milliseconds: "05:26.75" is 5 min 26.75 s. Reading it with parseInt turned ".75" into
       75 ms instead of 750 ms, so every clip time written with fewer than three fraction digits
       landed up to 0.9 s early. Producers mix the notations freely within one file - the SMIL of
       978-91-87221-16-3 starts with "28.39s" and switches to "01:04.79" past the first minute.

       parseFloat on the seconds part handles the fraction, and an absent fraction, on its own.
       */
      const timeParts = time.split(':');
      const seconds = parseFloat(timeParts.pop());
      const minutes = parseInt(timeParts.pop(), 10);
      const hours = timeParts.length ? parseInt(timeParts.pop(), 10) : 0;

      const number = hours * 3600 + minutes * 60 + seconds;

      return Number.isNaN(number) ? null : number;
    }
    if (time.includes('.') || time.includes('s')) {
      return parseFloat(time);
    }

    return parseInt(time);
  }

  return null;
}

const audioUtil = {
  timeStrToNumber,
};

export default audioUtil;
